import type { ApiMiddleware, BaseApiClientRequestConfig, BaseApiClientResponse } from '../types';

/**
 * Дефолтный миддлвар - набор интерцепторов для Axios, инкапсулированный в класс, реализующий внешним интерфейсом ApiMiddleware.
 * Используется для реализации прикладных миддлваров, упрощая написание тех методов ApiMiddleware, которые не нужны, представляя их дефолтную имплементацию.
 */
export class DefaultMiddleware implements ApiMiddleware {
    protected constructor(public readonly middlewareId: string) {}

    public requestInterceptor(
        request: BaseApiClientRequestConfig,
    ): BaseApiClientRequestConfig | Promise<BaseApiClientRequestConfig> {
        return request;
    }

    public responseInterceptor(
        response: BaseApiClientResponse,
    ): BaseApiClientResponse | Promise<BaseApiClientResponse> {
        return response;
    }

    public errorResponseHandler(error: any): any {
        throw error;
    }
}
